function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as responsive from './utils/responsive';
import color from './utils/color';
import shadow from './utils/shadow';
const fonts = {
  sansSerif: `
    'Inter',
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Helvetica,
    Arial,
    sans-serif,
    "Apple Color Emoji",
    "Segoe UI Emoji",
    "Segoe UI Symbol"
  `,
  serif: `
    'Charter',
    serif
  `,
  mono: `
    'SFMono-Regular',
    Consolas,
    "Liberation Mono",
    Menlo,
    Courier,
    monospace;
  `
};
export const lightTheme = {
  fontFamily: fonts.sansSerif,
  fonts,
  responsive,
  shadow,
  color: _objectSpread(_objectSpread({}, color), {}, {
    text: color.neutral['800'],
    label: color.neutral['500'],
    alternateBackground: color.neutral['50'],
    background: color.neutral['200'],
    surface: color.neutral['100'],
    surfaceHighlight: color.neutral['100'],
    elevatedSurface: '#ffffff',
    elevatedSurfaceHighlight: color.neutral['100'],
    border: color.neutral['300'],
    borderHover: color.neutral['500'],
    buttonPressed: color.neutral['800'],
    button: color.neutral['700'],
    buttonHover: color.neutral['600'],
    disabled: color.neutral['400'],
    lowEmphasis: color.neutral['600'],
    mediumEmphasis: color.neutral['800'],
    highEmphasis: color.neutral['1400']
  })
};
export const darkTheme = {
  fontFamily: fonts.sansSerif,
  fonts,
  responsive,
  shadow,
  color: _objectSpread(_objectSpread({}, color), {}, {
    text: color.neutral['100'],
    label: color.neutral['500'],
    alternateBackground: color.neutral['1600'],
    background: color.neutral['1600'],
    surface: color.neutral['1500'],
    surfaceHighlight: color.neutral['1300'],
    elevatedSurface: color.neutral['1400'],
    elevatedSurfaceHighlight: color.neutral['1200'],
    border: color.neutral['1200'],
    borderHover: color.neutral['1000'],
    buttonPressed: color.neutral['1100'],
    button: color.neutral['1000'],
    buttonHover: color.neutral['900'],
    disabled: color.neutral['800'],
    lowEmphasis: color.neutral['500'],
    mediumEmphasis: color.neutral['300'],
    highEmphasis: color.neutral['100']
  })
};